module.exports = __webpack_public_path__ + "static/media/Logo_blanco.592eeead.png";